import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { APIManagerConfig } from '../apiManager';
import { Operator, OperatorFormValues } from './operator.types';

const OperatorServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getOperatorsList: (includeDeleted = false): Promise<Operator[]> =>
      HTTPBase.get(`farm/${config.farmId}/drivers`, {
        params: {
          includeDeleted,
        },
      }).then((res) => res.data),
    getOperator: (operatorId: Operator['id']): Promise<Operator> =>
      HTTPBase.get(`farm/${config.farmId}/drivers/${operatorId}`).then((res) => res.data),
    createOperator: (payload: OperatorFormValues, formName: FormName): Promise<Operator> =>
      HTTPBase.post(`farm/${config.farmId}/drivers`, payload, { headers: { formName } }).then((res) => res.data),
    deleteOperator: (operatorId: Operator['id'], formName: FormName): Promise<{}> =>
      HTTPBase.delete(`farm/${config.farmId}/drivers/${operatorId}`, { headers: { formName } }).then((res) => res.data),
    updateOperator: (operatorId: Operator['id'], data: OperatorFormValues, formName: FormName) =>
      HTTPBase.patch(`farm/${config.farmId}/drivers/${operatorId}`, data, { headers: { formName } }).then(
        (res) => res.data,
      ),
  };
};

export default OperatorServiceFactory;
